{
  "sidebar": {
    "data": {
      "title": "Datos"
    },
    "insights": {
      "title": "Insights"
    },
    "instances_caches": {
      "title": "Caches"
    },
    "jvm": {
      "title": "JVM"
    },
    "logging": {
      "title": "Logging"
    },
    "security": {
      "title": "Seguridad"
    },
    "web": {
      "title": "Web"
    }
  }
}
